<script setup lang="ts">
  import { formatTime } from '@/common/services/time'
  import { PropType } from 'vue'
  import { AuditLog } from '@/common/graphql/types'
  import AuditLogTimelineItemUser from '@/common/components/auditlog/components/AuditLogTimelineItemUser.vue'
  import AuditLogTimelineItemSystem from '@/common/components/auditlog/components/AuditLogTimelineItemSystem.vue'

  defineProps({
    log: {
      type: Object as PropType<AuditLog>,
      required: true
    },
  })

  const components = {
    'system': AuditLogTimelineItemSystem,
    'user': AuditLogTimelineItemUser
  }

  function isSystemEvent (log: AuditLog) {
    return ['gets_committed', 'backup', 'loggedin', 'cleanup', 'automatic_cleanup', 'gets_imported'].includes(log.action)
  }
</script>

<template>
  <div class="flex gap-6 text-sm relative z-0">
    <div class="w-12 flex flex-col items-center">
      <div class="rounded-full bg-gray-400 size-[11px] mt-5" />
      <div
        :title="formatTime(log.created_at, { showSeconds: true })"
        class="text-2xs bg-gray-50 font-semibold text-gray-400 mt-1"
      >
        {{ formatTime(log.created_at) }}
      </div>
    </div>
    <component :is="isSystemEvent(log) ? components.system : components.user" :log="log" />
  </div>
</template>